import { TextLongLeftIcon } from '@zep-us/zus/icons';
import { Blue500, Green500, Pink400, Purple400 } from '@zep-us/zus/tokens';
import { CheckSmallCircleFillIcon, MessageLinesFillIcon } from '@/icons';
import { LocalizedOxTypeIcon } from '@/shared/components/LocalizedOxTypeIcon';
import { cn } from '@/utils';
const MultipleTypeIcon = () => {
  return <Container className="bg-green-50" data-sentry-element="Container" data-sentry-component="MultipleTypeIcon" data-sentry-source-file="QuizTypeIcon.tsx">
      <CheckSmallCircleFillIcon size="xs" fill={Green500} data-sentry-element="CheckSmallCircleFillIcon" data-sentry-source-file="QuizTypeIcon.tsx" />
    </Container>;
};
const SubjectiveTypeIcon = () => {
  return <Container className="bg-blue-50" data-sentry-element="Container" data-sentry-component="SubjectiveTypeIcon" data-sentry-source-file="QuizTypeIcon.tsx">
      <MessageLinesFillIcon size="xs" fill={Blue500} data-sentry-element="MessageLinesFillIcon" data-sentry-source-file="QuizTypeIcon.tsx" />
    </Container>;
};
const OxTypeIcon = () => {
  return <Container className="bg-purple-50" data-sentry-element="Container" data-sentry-component="OxTypeIcon" data-sentry-source-file="QuizTypeIcon.tsx">
      <LocalizedOxTypeIcon size="xs" fill={Purple400} data-sentry-element="LocalizedOxTypeIcon" data-sentry-source-file="QuizTypeIcon.tsx" />
    </Container>;
};
const EssayTypeIcon = () => {
  return <Container className="bg-pink-50" data-sentry-element="Container" data-sentry-component="EssayTypeIcon" data-sentry-source-file="QuizTypeIcon.tsx">
      <TextLongLeftIcon size="xs" fill={Pink400} data-sentry-element="TextLongLeftIcon" data-sentry-source-file="QuizTypeIcon.tsx" />
    </Container>;
};
export const QuizTypeIcon = {
  Multiple: MultipleTypeIcon,
  Subjective: SubjectiveTypeIcon,
  Ox: OxTypeIcon,
  Essay: EssayTypeIcon
};
const Container = ({
  children,
  className
}: {
  children: React.ReactNode;
  className: string;
}) => {
  return <div className="flex shrink-0 items-start py-4xs" data-sentry-component="Container" data-sentry-source-file="QuizTypeIcon.tsx">
      <div className={cn('flex size-[30px] items-center justify-center rounded-[8px]', className)}>
        {children}
      </div>
    </div>;
};